import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale/pt-BR';
import { useEffect, useState } from 'react';
import { useApi } from '../../hooks/useApi';
import ModalTolltip from '../Modal/Tooltip';

interface Props {
	icon: string | JSX.Element;
	title?: string;
	events: any[];
	disabled?: boolean;
}

export default function TooltipGames({
	icon,
	title = '',
	disabled = false,
	events,
}: Props) {
	const api = useApi();
	const [isOpen, setIsOpen] = useState(false);
	const handleClick = () => {
		setIsOpen(!isOpen);
	};

	useEffect(() => {
		const handleClickOutside = () => setIsOpen(false);

		document.addEventListener('click', handleClickOutside);
		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, []);

	return (
		<>
			<button
				onClick={(e: any) => {
					e.stopPropagation();
					if (disabled) return;
					handleClick();
				}}
			>
				{icon}
			</button>

			<ModalTolltip
				id="modalTooltip"
				open={isOpen}
				onClose={handleClick}
				infoIcon=""
				paddingCustom="p-4"
			>
				{title && (
					<h2 className="text-black text-lg font-semibold font-bahnschrift leading-7">
						{title}
					</h2>
				)}

				<div className="w-full grid lg:grid-cols-3">
					{events.map((event, index) => (
						<div
							onClick={() => {
								if (event.result === '') {
									return;
								}
								if (event.scores.length === 0) {
									return;
								}
							}}
							className="flex flex-col"
							key={index}
						>
							<div className="flex-row pt-1 justify-between items-start inline-flex">
								<div className="text-primary text-[11px] font-bold font-bahnschrift leading-snug">
									{event.championship.name}
								</div>
								<div className="text-primary text-[11px] font-bold font-bahnschrift leading-snug">
									{format(
										event.startAt.replace('Z', ''),
										"dd/MM • EEE • HH'h'mm",
										{ locale: ptBR }
									)}
								</div>
							</div>
							<div className="py-1 flex-col gap-px inline-flex ">
								<div className="grid grid-flow-col justify-between">
									<div className="flex w-28 flex-row justify-start">
										<div className="flex flex-row items-center gap-2">
											<img
												className="w-7 h-7 object-scale-down"
												src={event.home.image}
												alt={event.home.name}
											/>
											<span className="text-custom-black text-left text-xs font-bold font-bahnschrift leading-snug">
												{event.home.name}
											</span>
										</div>
									</div>
									<div className="flex w-16 flex-row justify-center items-center gap-1">
										<div className="text-[#818181] text-2xl font-bold font-bahnschrift leading-snug animate-slide-down">
											{event.gameStarted &&
												event.home.score}
										</div>
										<div className="text-[#818181] text-xs font-bold font-bahnschrift leading-snug">
											x
										</div>
										<div className="text-[#818181] text-2xl font-bold font-bahnschrift leading-snug animate-slide-down">
											{event.gameStarted &&
												event.away.score}
										</div>
									</div>
									<div className="flex w-28 flex-row justify-end ">
										<div className="flex flex-row items-center gap-2">
											<span className="text-custom-black text-right text-xs font-bold font-bahnschrift leading-snug">
												{event.away.name}
											</span>
											<img
												className="w-7 h-7 object-scale-down"
												src={event.away.image}
												alt={event.away.name}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					))}
				</div>
			</ModalTolltip>
		</>
	);
}
